import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postPlan } from "../../store/plans/actions";
export var usePlanPost = function (trigger, bodyRequest) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responsePostPlans: (_a = state.Plans.responsePostPlans) === null || _a === void 0 ? void 0 : _a.data,
            errorPostPlans: state.Plans.errorPostPlans,
            loadingPostPlans: state.Plans.loadingPostPlans,
        });
    }), responsePostPlans = _a.responsePostPlans, errorPostPlans = _a.errorPostPlans, loadingPostPlans = _a.loadingPostPlans;
    useEffect(function () {
        if (trigger) {
            dispatch(postPlan(bodyRequest));
        }
    }, [bodyRequest, trigger]);
    return {
        responsePostPlans: responsePostPlans,
        errorPostPlans: errorPostPlans,
        loadingPostPlans: loadingPostPlans,
    };
};
